const categories = [
  "Cross-border Trade",
  "Currency Arbitrage", 
  "Real Estate",
  "Commodities",
  "E-commerce",
  "Technology",
  "Agriculture",
  "Energy"
];

export function CategoriesSection({ isDark }) {
  return (
    <section className={`py-20 px-4 sm:px-6 lg:px-8 border-t ${isDark ? 'border-white/5' : 'border-gray-100'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-purple-500 text-sm font-semibold tracking-widest uppercase mb-4">Coverage</p>
          <h2 className={`text-3xl sm:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Opportunities Across All Markets
          </h2>
          <p className={`max-w-xl mx-auto ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            From commodities to crypto, real estate to forex - we analyze every market for the best daily opportunity.
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((cat) => (
            <span 
              key={cat}
              className={`px-4 py-2 rounded-full text-sm cursor-default transition-colors ${isDark ? 'bg-[#12121a] border border-white/10 text-gray-300 hover:border-purple-500/50 hover:text-purple-300' : 'bg-gray-100 border border-gray-200 text-gray-700 hover:border-purple-300 hover:text-purple-600'}`}
            >
              {cat}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
